{
  "error": {
    "propertyAlreadyAssigned": "Denne eiendommen er allerede registrert på andelseier \"{{shareholderName}}\" og kan ikke legges til ny andelseier før den fjernes fra den andre andelseieren.",
    "propertyAlreadyAssignedTitle": "Eiendom{{propertyDisplay}} allerede registrert",
    "anotherShareholder": "en annen andelseier"
  },
  "step2": {
    "title": "Eiendommer",
    "description": "Legg til alle eiendommene knyttet til organisasjon eller privatperson ved å bruke hovednummeret til hver eiendom",
    "loadingText": "Laster skogeiers eiendommer...",
    "transferWithShareOwnership": "Overføres sammen med andelseierskapet",
    "allPropertiesConfirmed": {
      "title": "Jeg har registrert alle eiendommene til andelseier",
      "description": "For å bli andelseier må vi ha registrert alle eiendommer knyttet til organisasjon eller privat person",
      "error": "Du må bekrefte at du har registrert alle eiendommene"
    },
    "summary": {
      "title": "Eiendommer",
      "mainNumber": "Hovednummer",
      "ownership": "Eierskap",
      "shareCapital": "Andelskapital",
      "total": "Sum",
      "noProperties": "Ingen eiendommer valgt"
    }
  },
  "step3": {
    "title": "Vernet areal",
    "description": "(velg hovednummer og) Legg inn vernet areal per eiendom, fordelt på høy, middels og lav bonitet",
    "groupLabel": "Hovednummer {{mainNumber}}{{municipalityName}}",
    "validation": {
      "exceedsTotalArea": "For høy verdi"
    }
  },
  "summary": {
    "personalInfo": "Personlig informasjon",
    "costs": "Kostnader",
    "submit": "Opprett andelseierskap"
  }
}
